import { validateField } from "@/utilities";

export default {
  computed: {
    passwordIsValid() {
      return this.password.length >= 8;
    },
    repeatPasswordIsValid() {
      return this.password === this.repeatPassword;
    }
  }
};
